import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component, OnInit } from '@angular/core';
import {
  ExcelService,
  InqRulesReorderInfo,
} from '../../services/common/excel.service';

@Component({
  selector: 'app-color-picker',
  template: ` <span class="notify-badge-inq-rules" >
                {{inqRuleOrder}}
                <img [src]="'assets/Inbox/decrementArrow.svg'" (click)="openInqReorderPanel($event, opInqReorder)" style="margin-left: 4px;">
              </span>
                <p-overlayPanel #opInqReorder  [appendTo]="'body'" [styleClass]="'qma-inq-rules-reorder'">
                  <div class="inq-rules-popup-header-container">
                      <img [src]="'assets/Inbox/close_choose_secondary_column.svg'" (click)="rearrangeInqRules($event, opInqReorder)">
                  </div>
                  <div  *ngFor="let option of routesList">
                    <div *ngIf="inqRuleOrder === option?.order" class="inqCurrentInputWrap">
                      <input class="inqCurrentInputStyle" [(ngModel)]="sliderInput" name="sliderInput">
                      <div class="incrementIconsWrap">
                        <img [src]="'assets/Inbox/decrementArrow.svg'" (click)="onDecrement()">
                        <img [src]="'assets/Inbox/incrementArrow.svg'" (click)="onIncrement()">
                      </div>
                    </div>  
                    <div class="inqNoNotInput" *ngIf="inqRuleOrder !== option?.order" >{{option?.order}}</div>
                  </div>
                </p-overlayPanel>`,
  styleUrls: ['./inquiry-order-component.scss'],
})
export class InquiryOrderComponent implements ICellRendererAngularComp, OnInit {
  public params: any;
  public gridApi: any;
  public sliderInput: number;
  public inqRuleOrder: number;
  public value: any;
  public maxRange: number;
  routesList: any[] = [];

  ngOnInit() {
    this.excelService.routesList$.subscribe((data) => {
      this.routesList = data;
    });
  }

  agInit(params: any): void {
    this.params = params;
    this.gridApi = params.api;
    this.sliderInput = this.params.value ? this.params.value : '';
    this.inqRuleOrder = this.params.value ? this.params.value : '';
    this.maxRange = this.gridApi.getDisplayedRowCount();
  }

  constructor(private excelService: ExcelService) {}

  onKeyDown(event): void {
    if (event.keyCode == 13) {
      this.updateValue();
    }
  }

  updateValue() {
    //this.params[this.fieldname] = this.getValue();
    //this.params.data.colorCode = this.colorCode;
  }
  getValue(): any {
    // return this.colorCode;
  }

  refresh(): boolean {
    return true;
  }

  openInqReorderPanel(event, overlayPanel) {
    // overlay should be closed only by using close buttom of popup
    if (!overlayPanel.visible) {
      overlayPanel.toggle(event);
    }
  }

  rearrangeInqRules(event, overlayPanel) {
    overlayPanel.hide();
    let inqRulesReorderInfo = new InqRulesReorderInfo();
    inqRulesReorderInfo.originalOrderNumber = this.inqRuleOrder;
    inqRulesReorderInfo.newOrderNumber = this.sliderInput;
    this.excelService.setinqRulesReorderInfo(inqRulesReorderInfo);
  }
  onIncrement() {
    if (this.sliderInput < this.maxRange) {
      this.sliderInput++;
    }
  }
  onDecrement() {
    if (this.sliderInput > 1) {
      this.sliderInput--;
    }
  }
}
